// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Info__container-ea3fb7 {
  padding: 0 16px;
}

.Info__color-container-f23a25 {
  min-width: 24px;
  height: 24px;
  margin-inline-end: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.Info__circle-ba989c {
  background-color: var(--brand-secondary-40);
  border-radius: 50%;
  width: 16px;
  height: 16px;
}

.Info__time-ee0855,
.Info__repeat-e18b6e,
.Info__reminder-f22996 {
  color: var(--base-80);
  font: var(--font-subhead-2);
  margin-bottom: 6px;
}

.Info__title-fcbd85 {
  display: flex;
  font: var(--font-title-8);
  margin-bottom: 8px;
  color: var(--base-110);
}

.Info__status-f3b26f {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.Info__call-link-container-d041e9 {
  display: flex;
  flex-direction: column;
  margin: 8px 0;
}

.Info__sub-title-da3b37 {
  font: var(--font-subtitle-4);
  color: var(--base-80);
  letter-spacing: var(--font-spacing-subtitle-4);
}

.Info__accept-c50ae3 {
  fill: var(--success-40);
}

.Info__decline-f34669 {
  fill: var(--danger-40);
}`, "",{"version":3,"sources":["webpack://./src/main/Calendar/Content/RightSidebar/Info/Info.styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,2CAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;;;EAGE,qBAAA;EACA,2BAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AACF;;AAEA;EACE,4BAAA;EACA,qBAAA;EACA,8CAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,sBAAA;AACF","sourcesContent":[".container {\n  padding: 0 16px;\n}\n\n.color-container {\n  min-width: 24px;\n  height: 24px;\n  margin-inline-end: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.circle {\n  background-color: var(--brand-secondary-40);\n  border-radius: 50%;\n  width: 16px;\n  height: 16px;\n}\n\n.time,\n.repeat,\n.reminder {\n  color: var(--base-80);\n  font: var(--font-subhead-2);\n  margin-bottom: 6px;\n}\n\n.title {\n  display: flex;\n  font: var(--font-title-8);\n  margin-bottom: 8px;\n  color: var(--base-110);\n}\n\n.status {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n}\n\n.call-link-container {\n  display: flex;\n  flex-direction: column;\n  margin: 8px 0;\n}\n\n.sub-title {\n  font: var(--font-subtitle-4);\n  color: var(--base-80);\n  letter-spacing: var(--font-spacing-subtitle-4);\n}\n\n.accept {\n  fill: var(--success-40);\n}\n\n.decline {\n  fill: var(--danger-40);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Info__container-ea3fb7`,
	"color-container": `Info__color-container-f23a25`,
	"colorContainer": `Info__color-container-f23a25`,
	"circle": `Info__circle-ba989c`,
	"time": `Info__time-ee0855`,
	"repeat": `Info__repeat-e18b6e`,
	"reminder": `Info__reminder-f22996`,
	"title": `Info__title-fcbd85`,
	"status": `Info__status-f3b26f`,
	"call-link-container": `Info__call-link-container-d041e9`,
	"callLinkContainer": `Info__call-link-container-d041e9`,
	"sub-title": `Info__sub-title-da3b37`,
	"subTitle": `Info__sub-title-da3b37`,
	"accept": `Info__accept-c50ae3`,
	"decline": `Info__decline-f34669`
};
module.exports = ___CSS_LOADER_EXPORT___;
